/**
 * ------------------------------------------------------------
 * Developer Name : Praveen Tripathi
 * Purpose        : Landing chrome dynamic imports (sticky CTAs)
 * ------------------------------------------------------------
 *
 * Sticky CTAs are deferred (ssr: false) — below-fold / mobile chrome.
 * Headers stay static imports in LandingHeaderFacade to avoid first-paint flicker.
 * Mirrors src/features/layout-primary/view/layout-dynamic.tsx.
 * Note: Turbopack requires dynamic() options as object literals.
 */

"use client";

import dynamic from "next/dynamic";
import { memo } from "react";

export const EnrollNowStickyLp = dynamic(
  () =>
    import("@/components/atoms/EnrollNowStickyLp/EnrollNowStickyLp").then(
      (mod) => ({ default: memo(mod.default) })
    ),
  { ssr: false, loading: () => null }
);

export const DownloadCTASticky = dynamic(
  () =>
    import(
      "@/components/molecules/LandingPageHeader/DownloadCTASticky/DownloadCTASticky"
    ).then((mod) => ({ default: memo(mod.default) })),
  { ssr: false, loading: () => null }
);
